"use client";

import { FC, PropsWithChildren } from "react";

import styles from "./layout.module.scss";

const AuthLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.layout}>
      <div className={styles.centerColumn}>{children}</div>
    </div>
  );
};

export default AuthLayout;
